import React  , { Component } from 'react'

import {  HomeSlider,
          HomeDeals,
          VideoSliderItem,
          HomeTitle  , ResponsiveYouTubeIframe,
          CoverSection       } from '../../Components/UI/UI'

import {  newPosts } from "../../Data/Data";
import { getWeather } from "../../Utility/Utility";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "../innerPage.css"
import "./ExporeTelAvivAndJerusalem.css"

class ExporeTelAvivAndJerusalem extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount () {

    getWeather((Weather)=>{
      
      //console.log("Weather", Weather);
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
  


  render(){
    

     // get all posts 
    const  posts = [ ...newPosts ] ;

    // get video posts 
    const nonVidPosts = posts.filter((o , i )=>{
      return ( o.isVid === true  || o.forVidPage === true) && o.isDouble === false;
    })


    const concertSHtml = nonVidPosts.map( (o,i) => {
        let cssClass="";
        let html ="";
        if ( i % 4 === 0 ) {
          cssClass =" first";
        }
       const url = "/Posts/Videos/" + o.ctg  + '/' + o.id;
 
        return <VideoSliderItem  
                  key={i}
                  title={o.title}
                  desc={""}
                  img= {o.img}
                  link={url}
                  cssClass={cssClass}
                 />
    });

    return(
      <div className="inner-page align-center page-ExporeTelAvivAndJerusalem">
        <Menu />
        {/*<HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />*/}
        <CoverSection desktopImg={'/posts/bank/page-videos/1.jpg'} mobileImg={'/posts/bank/page-videos/M.jpg'} cssClass={'telaviv'} waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather}/>
        
        <section className="live-shows-section">
          <div className="container">
            <HomeTitle>
              VIDEOS
            </HomeTitle>
            {/*<ResponsiveYouTubeIframe vidId={'FYtk8JMMZRE'} />*/}
            {/*<ResponsiveYouTubeIframe vidId={'ogEN7aRT0SM'} />*/}
            <ResponsiveYouTubeIframe vidId={'FYtk8JMMZRE'} />
            <div className="live-shows-wrapper">
              {concertSHtml}
             
            </div>
            <HomeDeals />
          </div>
        </section>
        <Footer />
      </div>
    )
  }

}



export default ExporeTelAvivAndJerusalem


// WEBPACK FOOTER //
// ./src/Pages/ExporeTelAvivAndJerusalem/ExporeTelAvivAndJerusalem.js